import styled from 'styled-components';

export const FiltersContainer = styled.div`
	display: flex;
`;
